/******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ({

/***/ "./resources/app.ts":
/*!**************************!*\
  !*** ./resources/app.ts ***!
  \**************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _scripts_components_Consent_Consent__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./scripts/components/Consent/Consent */ "./resources/scripts/components/Consent/Consent.ts");
/* harmony import */ var _scripts_components_Siblings_Siblings__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./scripts/components/Siblings/Siblings */ "./resources/scripts/components/Siblings/Siblings.ts");
/* harmony import */ var _scripts_components_Bundle_Bundle__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./scripts/components/Bundle/Bundle */ "./resources/scripts/components/Bundle/Bundle.ts");
/* harmony import */ var _scripts_components_Geolocator_Geolocator__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./scripts/components/Geolocator/Geolocator */ "./resources/scripts/components/Geolocator/Geolocator.ts");
/* Consent */

/* Siblings */

/* Bundle */

/* Geolocator */

var consent = new _scripts_components_Consent_Consent__WEBPACK_IMPORTED_MODULE_0__["default"]();
consent.init();
customElements.define('bundle-component', _scripts_components_Bundle_Bundle__WEBPACK_IMPORTED_MODULE_1__["default"]);
customElements.define('edition-siblings', _scripts_components_Siblings_Siblings__WEBPACK_IMPORTED_MODULE_2__["default"]);
customElements.define('geolocator-component', _scripts_components_Geolocator_Geolocator__WEBPACK_IMPORTED_MODULE_3__["default"]);

/***/ }),

/***/ "./resources/scripts/components/Bundle/Bundle.ts":
/*!*******************************************************!*\
  !*** ./resources/scripts/components/Bundle/Bundle.ts ***!
  \*******************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ Bundle)
/* harmony export */ });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }
/* eslint-disable prefer-arrow-callback */
/* eslint-disable func-names */
/* eslint-disable prefer-template */
/* eslint-disable class-methods-use-this */
/* eslint-disable consistent-return */
/* eslint-disable no-console */
var Bundle = /*#__PURE__*/function (_HTMLElement) {
  function Bundle() {
    var _this;
    _classCallCheck(this, Bundle);
    _this = _callSuper(this, Bundle);
    _defineProperty(_this, "bundleItems", Array.from(_this.querySelectorAll('.bundle-item')));
    _defineProperty(_this, "addToCartButton", _this.closest('.main-product').querySelector('.buy-buttons').querySelector('button[type="submit"]'));
    _defineProperty(_this, "productUrl", _this.dataset.producturl);
    _defineProperty(_this, "loadingOverlay", _this.querySelector('.loading-overlay'));
    _this.initEventListeners = _this.initEventListeners.bind(_this);
    _this.moveOverlaysOutOfMain = _this.moveOverlaysOutOfMain.bind(_this);
    _this.toggleBundleItemDrawer = _this.toggleBundleItemDrawer.bind(_this);
    _this.addBundleDrawerEventListeners = _this.addBundleDrawerEventListeners.bind(_this);
    _this.handleSizeSelectChange = _this.handleSizeSelectChange.bind(_this);
    _this.addToBundle = _this.addToBundle.bind(_this);
    _this.toggleDisableStateAddToCartButton = _this.toggleDisableStateAddToCartButton.bind(_this);
    _this.handleAddBundleToCart = _this.handleAddBundleToCart.bind(_this);
    _this.toggleCartDrawer = _this.toggleCartDrawer.bind(_this);
    _this.updateBundlePreorderText = _this.updateBundlePreorderText.bind(_this);
    return _this;
  }
  _inherits(Bundle, _HTMLElement);
  return _createClass(Bundle, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      this.toggleDisableStateAddToCartButton(this.addToCartButton);
      this.moveOverlaysOutOfMain();
      this.initEventListeners();
    }
  }, {
    key: "initEventListeners",
    value: function initEventListeners() {
      var _this2 = this;
      this.bundleItems.forEach(function (item) {
        item.addEventListener('click', function (event) {
          event.preventDefault();
          _this2.handleBundleItemClicked(item);
        });
      });
      this.addToCartButton.addEventListener('click', /*#__PURE__*/function () {
        var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(event) {
          return _regenerator().w(function (_context) {
            while (1) switch (_context.n) {
              case 0:
                event.preventDefault();
                _context.n = 1;
                return _this2.handleAddBundleToCart();
              case 1:
                return _context.a(2);
            }
          }, _callee);
        }));
        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    }
  }, {
    key: "handleBundleItemClicked",
    value: function handleBundleItemClicked(item) {
      this.toggleBundleItemDrawer(item);
    }
    // Theme specific methods to move overlays ontop of the header
  }, {
    key: "moveOverlaysOutOfMain",
    value: function moveOverlaysOutOfMain() {
      var overlays = Array.from(this.querySelectorAll('.bundle-item-overlay'));
      overlays.forEach(function (overlay) {
        document.body.appendChild(overlay);
      });
    }
  }, {
    key: "toggleBundleItemDrawer",
    value: function toggleBundleItemDrawer(item) {
      var itemId = item.id;
      var overlay = document.querySelector(".bundle-item-overlay[data-target=\"".concat(itemId, "\"]"));
      var drawer = overlay.querySelector('.bundle-item-drawer');
      var isCurrentlyOpen = overlay.getAttribute('aria-hidden') === 'false';
      if (isCurrentlyOpen) {
        // Animate out
        drawer.style.transform = 'translateX(100%)';
        setTimeout(function () {
          overlay.setAttribute('aria-hidden', 'true');
          drawer.setAttribute('aria-hidden', 'true');
          document.body.style.overflow = '';
        }, 250); // Wait for the transition before hiding
      } else {
        // Open the overlay immediately
        overlay.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
        setTimeout(function () {
          drawer.setAttribute('aria-hidden', 'false');
          drawer.style.transform = 'translateX(0)';
        }, 1);
      }
      this.addBundleDrawerEventListeners(overlay, item);
    }
  }, {
    key: "addBundleDrawerEventListeners",
    value: function addBundleDrawerEventListeners(overlay, item) {
      var _this3 = this;
      var closeBundleToggle = overlay.querySelector('.overlay-toggle');
      // Only add the event listener once
      if (!closeBundleToggle.hasAttribute('data-event-listener')) {
        closeBundleToggle.addEventListener('click', function (event) {
          event.preventDefault();
          _this3.toggleBundleItemDrawer(item);
          console.log('closeBundleToggle');
        });
        closeBundleToggle.setAttribute('data-event-listener', 'true');
      }
      // if clicking on the overlay, close the drawer
      overlay.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
        if (event.target === overlay) {
          _this3.toggleBundleItemDrawer(item);
        }
      });
      var selectSizeElements = Array.from(overlay.querySelectorAll('select'));
      selectSizeElements.forEach(function (select) {
        // Sync button state with the select's current value on drawer open
        _this3.handleSizeSelectChange(select);
        if (!select.hasAttribute('data-event-listener')) {
          select.addEventListener('change', function () {
            _this3.handleSizeSelectChange(select);
          });
          select.setAttribute('data-event-listener', 'true');
        }
      });
      var addToBundleButtons = Array.from(overlay.querySelectorAll('.add-to-bundle'));
      addToBundleButtons.forEach(function (button) {
        if (!button.hasAttribute('data-event-listener')) {
          button.addEventListener('click', function (event) {
            event.preventDefault();
            _this3.addToBundle(button);
          });
          button.setAttribute('data-event-listener', 'true');
        }
      });
    }
    // eslint-disable-next-line class-methods-use-this
  }, {
    key: "handleSizeSelectChange",
    value: function handleSizeSelectChange(select) {
      var closestBundleItem = select.closest('.bundle-item-info-wrapper');
      var addToBundleButton = closestBundleItem.querySelector('.add-to-bundle');
      var selectedOption = select.options[select.selectedIndex];
      var isAvailable = !selectedOption.disabled;
      var isPreorder = selectedOption.dataset.preorder === 'true';
      addToBundleButton.setAttribute('data-id', select.value);
      addToBundleButton.setAttribute('data-title', selectedOption.dataset.title);
      addToBundleButton.setAttribute('data-available', isAvailable ? 'true' : 'false');
      addToBundleButton.setAttribute('data-preorder', isPreorder ? 'true' : 'false');
      addToBundleButton.setAttribute('data-delivery', selectedOption.dataset.delivery || '');
      var buttonSpan = addToBundleButton.querySelector('span');
      if (isAvailable) {
        addToBundleButton.classList.remove('disabled');
        buttonSpan.textContent = addToBundleButton.dataset.addText;
      } else {
        addToBundleButton.classList.add('disabled');
        buttonSpan.textContent = addToBundleButton.dataset.soldOutText;
      }
    }
  }, {
    key: "addToBundle",
    value: function addToBundle(button) {
      if (button.getAttribute('data-available') !== 'true') return;
      var _button$dataset = button.dataset,
        color = _button$dataset.color,
        id = _button$dataset.id,
        image = _button$dataset.image,
        title = _button$dataset.title;
      // Get the id of the drawer, so we can find the corresponding item
      var closestOverlay = button.closest('.bundle-item-overlay');
      var overlayId = closestOverlay.getAttribute('data-target');
      // Get the item that corresponds to the overlay
      var item = document.querySelector("#".concat(overlayId));
      // mark the bundle as selected
      item.setAttribute('aria-selected', 'true');
      var bundleItemInfoWrapper = item.querySelector('.bundle-item-selection');
      // replace the image with the selected image
      var imageElement = bundleItemInfoWrapper.querySelector('.bundle-item-image');
      imageElement.src = image;
      // replace the color with the selected color
      var colorElement = bundleItemInfoWrapper.querySelector('.bundle-item-color');
      colorElement.textContent = color;
      // replace the title with the selected title
      var titleElement = bundleItemInfoWrapper.querySelector('.bundle-item-title');
      var titleWrapper = item.querySelector('.bundle-title-wrapper');
      if (title === 'Default Title') {
        titleElement.textContent = '';
        titleWrapper.classList.add('tw-opacity-0');
      } else {
        titleElement.textContent = title;
        titleWrapper.classList.remove('tw-opacity-0');
      }
      if (titleElement.textContent === '') {
        titleWrapper.classList.add('tw-hidden');
      } else {
        titleWrapper.classList.remove('tw-hidden');
      }
      // toggle preorder badge + expected delivery in the selection card
      var preorderBadge = bundleItemInfoWrapper.querySelector('.bundle-item-preorder-badge');
      var preorderDelivery = bundleItemInfoWrapper.querySelector('.bundle-item-preorder-delivery');
      var deliveryDateElement = bundleItemInfoWrapper.querySelector('.bundle-item-delivery-date');
      var isPreorderSelection = button.dataset.preorder === 'true';
      var deliveryDate = button.dataset.delivery || '';
      if (preorderBadge) preorderBadge.hidden = !isPreorderSelection;
      if (preorderDelivery) {
        if (isPreorderSelection && deliveryDate) {
          if (deliveryDateElement) deliveryDateElement.textContent = deliveryDate;
          preorderDelivery.hidden = false;
        } else {
          preorderDelivery.hidden = true;
        }
      }
      // replace the id and handle with the selected variant's values
      item.setAttribute('data-id', id);
      item.setAttribute('data-handle', button.dataset.handle);
      item.setAttribute('data-preorder', button.dataset.preorder || 'false');
      item.setAttribute('data-delivery', button.dataset.delivery || '');
      item.setAttribute('data-color', button.dataset.color || '');
      item.setAttribute('data-title', button.dataset.title || '');
      // close the drawer
      this.toggleBundleItemDrawer(item);
      this.toggleDisableStateAddToCartButton(this.addToCartButton);
      this.updateBundlePreorderText();
    }
  }, {
    key: "updateBundlePreorderText",
    value: function updateBundlePreorderText() {
      var mainProduct = this.closest('.main-product') || document;
      var preorderText = mainProduct.querySelector('[data-js-preorder-text]');
      var preorderDate = mainProduct.querySelector('[data-js-preorder-date]');
      if (!preorderText || !preorderDate) return;
      var dates = [];
      this.bundleItems.forEach(function (item) {
        if (item.getAttribute('aria-selected') !== 'true') return;
        if (item.getAttribute('data-preorder') !== 'true') return;
        var date = item.getAttribute('data-delivery') || '';
        if (date && dates.indexOf(date) === -1) dates.push(date);
      });
      if (dates.length > 0) {
        preorderDate.textContent = dates.join(', ');
        preorderText.style.display = '';
      } else {
        preorderDate.textContent = '';
        preorderText.style.display = 'none';
      }
    }
  }, {
    key: "buildPreorderProperties",
    value: function buildPreorderProperties() {
      var properties = {};
      this.bundleItems.forEach(function (item, index) {
        if (item.getAttribute('data-preorder') !== 'true') return;
        var delivery = item.getAttribute('data-delivery') || '';
        if (!delivery) return;
        var color = item.getAttribute('data-color') || '';
        var title = item.getAttribute('data-title') || '';
        var label = color;
        if (title && title !== 'Default Title') {
          label = label ? "".concat(label, " \u2014 ").concat(title) : title;
        }
        if (!label) label = "Component ".concat(index + 1);
        if (properties[label]) label = "".concat(label, " (#").concat(index + 1, ")");
        properties[label] = "Forventet levering: ".concat(delivery);
      });
      return properties;
    }
  }, {
    key: "toggleDisableStateAddToCartButton",
    value: function toggleDisableStateAddToCartButton(button) {
      button.disabled = this.bundleItems.every(function (item) {
        return item.getAttribute('aria-selected') !== 'true';
      });
    }
  }, {
    key: "checkComponentsAvailability",
    value: function () {
      var _checkComponentsAvailability = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(components) {
        var results;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              _context3.n = 1;
              return Promise.all(components.map(/*#__PURE__*/function () {
                var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(_ref2) {
                  var id, handle, preorder, response, product, variant;
                  return _regenerator().w(function (_context2) {
                    while (1) switch (_context2.n) {
                      case 0:
                        id = _ref2.id, handle = _ref2.handle, preorder = _ref2.preorder;
                        _context2.n = 1;
                        return fetch("/products/".concat(handle, ".js"));
                      case 1:
                        response = _context2.v;
                        _context2.n = 2;
                        return response.json();
                      case 2:
                        product = _context2.v;
                        variant = product.variants.find(function (v) {
                          return v.id === parseInt(id, 10);
                        });
                        return _context2.a(2, (variant === null || variant === void 0 ? void 0 : variant.available) === true || preorder === true);
                    }
                  }, _callee2);
                }));
                return function (_x3) {
                  return _ref3.apply(this, arguments);
                };
              }()));
            case 1:
              results = _context3.v;
              return _context3.a(2, results.every(Boolean));
          }
        }, _callee3);
      }));
      function checkComponentsAvailability(_x2) {
        return _checkComponentsAvailability.apply(this, arguments);
      }
      return checkComponentsAvailability;
    }() // eslint-disable-next-line consistent-return
  }, {
    key: "handleAddBundleToCart",
    value: function () {
      var _handleAddBundleToCart = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var shop, bundleComponents, bundleComponentsWithHandles, allAvailable, _window$KROWN, token, metaobjectId, productId, body, response, refreshedToken, retryResponse, data, bundle, message, variant, _t;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.p = _context4.n) {
            case 0:
              _context4.p = 0;
              this.loadingOverlay.style.display = 'flex';
              shop = window.Shopify.shop;
              bundleComponents = this.bundleItems.map(function (item) {
                return item.getAttribute('data-id');
              });
              bundleComponentsWithHandles = this.bundleItems.map(function (item) {
                return {
                  id: item.getAttribute('data-id'),
                  handle: item.getAttribute('data-handle'),
                  preorder: item.getAttribute('data-preorder') === 'true'
                };
              });
              _context4.n = 1;
              return this.checkComponentsAvailability(bundleComponentsWithHandles);
            case 1:
              allAvailable = _context4.v;
              if (allAvailable) {
                _context4.n = 2;
                break;
              }
              // eslint-disable-next-line no-alert
              alert(((_window$KROWN = window.KROWN) === null || _window$KROWN === void 0 || (_window$KROWN = _window$KROWN.settings) === null || _window$KROWN === void 0 || (_window$KROWN = _window$KROWN.locales) === null || _window$KROWN === void 0 ? void 0 : _window$KROWN.bundle_component_sold_out) || 'One or more products in your bundle are sold out. Please update your selection.');
              return _context4.a(2);
            case 2:
              _context4.n = 3;
              return this.getJwtToken(shop);
            case 3:
              token = _context4.v;
              // Get the JWT token (or refresh if expired)
              metaobjectId = this.getAttribute('data-metaobjectid');
              productId = this.getAttribute('data-productid');
              body = {
                productId: productId,
                bundleComponents: bundleComponents,
                metaobjectId: metaobjectId,
                shop: shop
              };
              _context4.n = 4;
              return fetch('http://bundle-app.edition.dk/api/bundle', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                  Authorization: "Bearer ".concat(token) // Use the JWT token
                },
                body: JSON.stringify(body)
              });
            case 4:
              response = _context4.v;
              if (response.ok) {
                _context4.n = 10;
                break;
              }
              if (!(response.status === 401)) {
                _context4.n = 9;
                break;
              }
              // Token expired or unauthorized
              console.log('Token expired. Attempting to refresh token...');
              _context4.n = 5;
              return this.getJwtToken(window.Shopify.shop);
            case 5:
              refreshedToken = _context4.v;
              _context4.n = 6;
              return fetch('http://bundle-app.edition.dk/api/bundle', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                  Authorization: "Bearer ".concat(refreshedToken)
                },
                body: JSON.stringify(body)
              });
            case 6:
              retryResponse = _context4.v;
              if (retryResponse.ok) {
                _context4.n = 7;
                break;
              }
              throw new Error('Failed to add bundle to cart');
            case 7:
              _context4.n = 8;
              return retryResponse.json();
            case 8:
              return _context4.a(2, _context4.v);
            case 9:
              throw new Error('Failed to add bundle to cart');
            case 10:
              _context4.n = 11;
              return response.json();
            case 11:
              data = _context4.v;
              // eslint-disable-next-line @typescript-eslint/no-unused-vars
              bundle = data.bundle, message = data.message, variant = data.variant;
              _context4.n = 12;
              return this.addVariantToCart(variant, this.buildPreorderProperties());
            case 12:
              _context4.n = 14;
              break;
            case 13:
              _context4.p = 13;
              _t = _context4.v;
              console.error('Error adding bundle to cart:', _t);
            case 14:
              _context4.p = 14;
              this.loadingOverlay.style.display = 'none';
              return _context4.f(14);
            case 15:
              return _context4.a(2);
          }
        }, _callee4, this, [[0, 13, 14, 15]]);
      }));
      function handleAddBundleToCart() {
        return _handleAddBundleToCart.apply(this, arguments);
      }
      return handleAddBundleToCart;
    }() // eslint-disable-next-line class-methods-use-this
  }, {
    key: "toggleCartDrawer",
    value: function toggleCartDrawer() {
      // Check if refreshCart exists on window before calling it
      if (typeof window.refreshCart === 'function') {
        window.refreshCart();
      }
      this.loadingOverlay.style.display = 'none';
    }
  }, {
    key: "addVariantToCart",
    value: function () {
      var _addVariantToCart = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(variant, properties) {
        var cartBody, response, _t2;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.p = _context5.n) {
            case 0:
              _context5.p = 0;
              cartBody = {
                id: variant,
                quantity: 1
              };
              if (properties && Object.keys(properties).length > 0) {
                cartBody.properties = properties;
              }
              _context5.n = 1;
              return fetch('/cart/add.js', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify(cartBody)
              });
            case 1:
              response = _context5.v;
              if (response.ok) {
                _context5.n = 2;
                break;
              }
              throw new Error('Failed to add variant to cart');
            case 2:
              _context5.n = 3;
              return this.waitForBundlePriceToSettle(variant);
            case 3:
              this.toggleCartDrawer();
              _context5.n = 5;
              break;
            case 4:
              _context5.p = 4;
              _t2 = _context5.v;
              console.error(_t2);
            case 5:
              return _context5.a(2);
          }
        }, _callee5, this, [[0, 4]]);
      }));
      function addVariantToCart(_x4, _x5) {
        return _addVariantToCart.apply(this, arguments);
      }
      return addVariantToCart;
    }() // Poll /cart.js until the newly added bundle line item has a non-zero
    // final_line_price (i.e. the bundle discount/transform has been applied),
    // or until we hit the timeout, whichever comes first.
  }, {
    key: "waitForBundlePriceToSettle",
    value: function () {
      var _waitForBundlePriceToSettle = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6(variant) {
        var _ref4,
          _ref4$attempts,
          attempts,
          _ref4$delay,
          delay,
          variantId,
          attempt,
          response,
          cart,
          item,
          _args6 = arguments,
          _t3;
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.p = _context6.n) {
            case 0:
              _ref4 = _args6.length > 1 && _args6[1] !== undefined ? _args6[1] : {}, _ref4$attempts = _ref4.attempts, attempts = _ref4$attempts === void 0 ? 10 : _ref4$attempts, _ref4$delay = _ref4.delay, delay = _ref4$delay === void 0 ? 300 : _ref4$delay;
              variantId = parseInt(variant, 10);
              attempt = 0;
            case 1:
              if (!(attempt < attempts)) {
                _context6.n = 9;
                break;
              }
              _context6.p = 2;
              _context6.n = 3;
              return fetch('/cart.js', {
                headers: {
                  Accept: 'application/json'
                }
              });
            case 3:
              response = _context6.v;
              _context6.n = 4;
              return response.json();
            case 4:
              cart = _context6.v;
              item = (cart.items || []).find(function (i) {
                return i.variant_id === variantId;
              }); // Line is present and has been repriced above 0 — safe to render.
              if (!(item && item.final_line_price > 0)) {
                _context6.n = 5;
                break;
              }
              return _context6.a(2);
            case 5:
              _context6.n = 7;
              break;
            case 6:
              _context6.p = 6;
              _t3 = _context6.v;
              console.error('Error while waiting for bundle price to settle', _t3);
            case 7:
              _context6.n = 8;
              return new Promise(function (resolve) {
                setTimeout(resolve, delay);
              });
            case 8:
              attempt += 1;
              _context6.n = 1;
              break;
            case 9:
              return _context6.a(2);
          }
        }, _callee6, null, [[2, 6]]);
      }));
      function waitForBundlePriceToSettle(_x6) {
        return _waitForBundlePriceToSettle.apply(this, arguments);
      }
      return waitForBundlePriceToSettle;
    }()
  }, {
    key: "getJwtToken",
    value: function () {
      var _getJwtToken = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7(shop) {
        var token, _t4;
        return _regenerator().w(function (_context7) {
          while (1) switch (_context7.p = _context7.n) {
            case 0:
              _context7.p = 0;
              token = localStorage.getItem('jwtTokenBundle'); // If no token, or the token is expired, request a new one
              if (!(!token || this.isTokenExpired(token))) {
                _context7.n = 2;
                break;
              }
              console.log('Token expired or missing. Getting a new token...');
              _context7.n = 1;
              return this.refreshJwtToken(shop);
            case 1:
              token = _context7.v;
            case 2:
              return _context7.a(2, token);
            case 3:
              _context7.p = 3;
              _t4 = _context7.v;
              console.error('Failed to get JWT token', _t4);
            case 4:
              return _context7.a(2);
          }
        }, _callee7, this, [[0, 3]]);
      }));
      function getJwtToken(_x7) {
        return _getJwtToken.apply(this, arguments);
      }
      return getJwtToken;
    }() // Check if the token is expired
  }, {
    key: "isTokenExpired",
    value: function isTokenExpired(token) {
      var decodedToken = this.decodeJwtToken(token);
      if (decodedToken && decodedToken.exp) {
        var expiry = decodedToken.exp * 1000; // Convert to milliseconds
        return Date.now() > expiry;
      }
      return false;
    }
    // Decode JWT token (you can use any JWT library here)
  }, {
    key: "decodeJwtToken",
    value: function decodeJwtToken(token) {
      try {
        var base64Url = token.split('.')[1];
        var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        var jsonPayload = decodeURIComponent(atob(base64).split('').map(function (c) {
          return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        }).join(''));
        return JSON.parse(jsonPayload);
      } catch (e) {
        console.error('Failed to decode JWT token', e);
        return null;
      }
    }
    // Refresh the JWT token
  }, {
    key: "refreshJwtToken",
    value: function () {
      var _refreshJwtToken = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8(shop) {
        var response, data, jwtToken;
        return _regenerator().w(function (_context8) {
          while (1) switch (_context8.n) {
            case 0:
              _context8.n = 1;
              return fetch('http://bundle-app.edition.dk/api/auth', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                  shop: shop
                }) // Send shop identifier
              });
            case 1:
              response = _context8.v;
              if (response.ok) {
                _context8.n = 2;
                break;
              }
              throw new Error('Failed to refresh token');
            case 2:
              _context8.n = 3;
              return response.json();
            case 3:
              data = _context8.v;
              jwtToken = data.token;
              localStorage.setItem('jwtTokenBundle', jwtToken);
              return _context8.a(2, jwtToken);
          }
        }, _callee8);
      }));
      function refreshJwtToken(_x8) {
        return _refreshJwtToken.apply(this, arguments);
      }
      return refreshJwtToken;
    }()
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));


/***/ }),

/***/ "./resources/scripts/components/Consent/Consent.ts":
/*!*********************************************************!*\
  !*** ./resources/scripts/components/Consent/Consent.ts ***!
  \*********************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ Consent)
/* harmony export */ });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }
var Consent = /*#__PURE__*/function () {
  // declare dataLayer
  function Consent() {
    _classCallCheck(this, Consent);
    this.init = this.init.bind(this);
    this.handleConsent = this.handleConsent.bind(this);
    this.checkConsentBannerInteraction = this.checkConsentBannerInteraction.bind(this);
    this.gtag = this.gtag.bind(this);
    this.recallConsent = this.recallConsent.bind(this);
  }
  // methods
  return _createClass(Consent, [{
    key: "init",
    value: function () {
      var _init = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var _this = this;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              window.Shopify.loadFeatures([{
                name: 'consent-tracking-api',
                version: '0.1'
              }], function (error) {
                if (error) {
                  console.error('Error loading features: ', error);
                  return;
                }
                console.log('Consent tracking API loaded');
                _this.initConsentComponent();
              });
            case 1:
              return _context.a(2);
          }
        }, _callee);
      }));
      function init() {
        return _init.apply(this, arguments);
      }
      return init;
    }()
  }, {
    key: "initConsentComponent",
    value: function () {
      var _initConsentComponent = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var _this2 = this;
        var recallConsentElement;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              window.dataLayer = window.dataLayer || [];
              this.handleConsent('default');
              document.addEventListener('visitorConsentCollected', /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
                return _regenerator().w(function (_context2) {
                  while (1) switch (_context2.n) {
                    case 0:
                      _this2.handleConsent('update');
                    case 1:
                      return _context2.a(2);
                  }
                }, _callee2);
              })));
              recallConsentElement = document.getElementById('recall-consent');
              if (recallConsentElement) {
                recallConsentElement.addEventListener('click', function (event) {
                  event.preventDefault();
                  _this2.recallConsent();
                });
              }
            case 1:
              return _context3.a(2);
          }
        }, _callee3, this);
      }));
      function initConsentComponent() {
        return _initConsentComponent.apply(this, arguments);
      }
      return initConsentComponent;
    }()
  }, {
    key: "handleConsent",
    value: function () {
      var _handleConsent = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(state) {
        var visitorConsent, consent;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              _context4.n = 1;
              return window.Shopify.customerPrivacy.currentVisitorConsent();
            case 1:
              visitorConsent = _context4.v;
              consent = {
                functionality_storage: visitorConsent.preferences === 'yes' ? 'granted' : 'granted',
                analytics_storage: visitorConsent.analytics === 'yes' ? 'granted' : 'denied',
                personalization_storage: visitorConsent.analytics === 'yes' ? 'granted' : 'granted',
                ad_storage: visitorConsent.marketing === 'yes' ? 'granted' : 'denied',
                ad_user_data: visitorConsent.marketing === 'yes' ? 'granted' : 'denied',
                ad_personalization: visitorConsent.marketing === 'yes' ? 'granted' : 'denied',
                wait_for_update: 500
              };
              this.gtag('consent', state, consent);
              // set local Storage for consent settings for further use on other pages or after page
              localStorage.setItem('consentSettings', JSON.stringify(consent));
            case 2:
              return _context4.a(2);
          }
        }, _callee4, this);
      }));
      function handleConsent(_x) {
        return _handleConsent.apply(this, arguments);
      }
      return handleConsent;
    }() /* eslint-disable */
  }, {
    key: "checkConsentBannerInteraction",
    value: (function () {
      var _checkConsentBannerInteraction = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        var visitorConsent;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              _context5.n = 1;
              return window.Shopify.customerPrivacy.currentVisitorConsent();
            case 1:
              visitorConsent = _context5.v;
              if (!(visitorConsent.preferences === '' && visitorConsent.analytics === '' && visitorConsent.marketing === '')) {
                _context5.n = 2;
                break;
              }
              return _context5.a(2, false);
            case 2:
              return _context5.a(2, true);
          }
        }, _callee5);
      }));
      function checkConsentBannerInteraction() {
        return _checkConsentBannerInteraction.apply(this, arguments);
      }
      return checkConsentBannerInteraction;
    }()
    /* eslint-disable */
    /* eslint-disable */
    )
  }, {
    key: "gtag",
    value: function gtag() {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      window.dataLayer.push(arguments);
    }
    /* eslint-enable */
    /* eslint-disable */
  }, {
    key: "recallConsent",
    value: (function () {
      var _recallConsent = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6() {
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.n) {
            case 0:
              window.privacyBanner.showPreferences();
            case 1:
              return _context6.a(2);
          }
        }, _callee6);
      }));
      function recallConsent() {
        return _recallConsent.apply(this, arguments);
      }
      return recallConsent;
    }())
  }]);
}();


/***/ }),

/***/ "./resources/scripts/components/Geolocator/Geolocator.ts":
/*!***************************************************************!*\
  !*** ./resources/scripts/components/Geolocator/Geolocator.ts ***!
  \***************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ Geolocator)
/* harmony export */ });
/* harmony import */ var _utils_CookieMethods__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../utils/CookieMethods */ "./resources/scripts/utils/CookieMethods.ts");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }

var Geolocator = /*#__PURE__*/function (_HTMLElement) {
  function Geolocator() {
    var _this;
    _classCallCheck(this, Geolocator);
    _this = _callSuper(this, Geolocator);
    _defineProperty(_this, "geolocatorScript", void 0);
    _defineProperty(_this, "countryDataArray", void 0);
    _defineProperty(_this, "geolocatorContentTemplate", void 0);
    _defineProperty(_this, "geolocatorContentPlaceholder", void 0);
    _defineProperty(_this, "modal", void 0);
    _defineProperty(_this, "closeModalButton", void 0);
    _defineProperty(_this, "closeCountryListModalButton", void 0);
    _defineProperty(_this, "countryModalToggle", void 0);
    _defineProperty(_this, "countryListModal", void 0);
    _defineProperty(_this, "countryListModalToggles", void 0);
    _defineProperty(_this, "countryListButtons", void 0);
    _defineProperty(_this, "stayButton", void 0);
    _defineProperty(_this, "leaveButton", void 0);
    _defineProperty(_this, "overlay", void 0);
    _defineProperty(_this, "allEuCountries", ['AT', 'BE', 'BG', 'CY', 'CZ', 'DE', 'EE', 'ES', 'FI', 'FR', 'GB', 'GR', 'HR', 'HU', 'IE', 'IS', 'IT', 'LT', 'LU', 'LV', 'MC', 'MK', 'MT', 'NL', 'NO', 'PL', 'PT', 'RO', 'SE', 'SI', 'SK', 'EU']);
    _this.getBrowsingContext = _this.getBrowsingContext.bind(_this);
    return _this;
  }
  _inherits(Geolocator, _HTMLElement);
  return _createClass(Geolocator, [{
    key: "connectedCallback",
    value: function () {
      var _connectedCallback = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var _browsingContext$sugg, _browsingContext$dete;
        var isCookied, browsingContext, activeCountry, visitorCountry, recommendedMatch;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              this.initDataAndElements();
              this.addEventListeners();
              this.handleGeolocationCookie();
              isCookied = (0,_utils_CookieMethods__WEBPACK_IMPORTED_MODULE_0__.getCookie)('geolocation');
              if (!isCookied) {
                _context.n = 1;
                break;
              }
              // eslint-disable-next-line no-console
              console.log('Geolocation cookie is set. Geolocator will not run.');
              return _context.a(2);
            case 1:
              _context.n = 2;
              return this.getBrowsingContext();
            case 2:
              browsingContext = _context.v;
              activeCountry = this.getActiveCountryAndLanguage();
              visitorCountry = (browsingContext === null || browsingContext === void 0 || (_browsingContext$sugg = browsingContext.suggestedCountry) === null || _browsingContext$sugg === void 0 ? void 0 : _browsingContext$sugg.handle) || (browsingContext === null || browsingContext === void 0 || (_browsingContext$dete = browsingContext.detectedCountry) === null || _browsingContext$dete === void 0 ? void 0 : _browsingContext$dete.handle); // Visitor is in the EU region and already on the EU market, so there is nothing to suggest
              if (!(this.allEuCountries.includes(activeCountry.country) && this.allEuCountries.includes(visitorCountry))) {
                _context.n = 3;
                break;
              }
              // eslint-disable-next-line no-console
              console.log('Active country and visitor country are in the EU region. Geolocator will not run.');
              return _context.a(2);
            case 3:
              recommendedMatch = this.getRecommendedMatch(browsingContext);
              if (recommendedMatch) {
                _context.n = 4;
                break;
              }
              return _context.a(2);
            case 4:
              if (!((recommendedMatch === null || recommendedMatch === void 0 ? void 0 : recommendedMatch.handle) === activeCountry.country)) {
                _context.n = 5;
                break;
              }
              // eslint-disable-next-line no-console
              console.log('Recommended match is the same as the active country. Geolocator will not run.');
              return _context.a(2);
            case 5:
              this.toggleGeolocator();
              this.setupGeolocatorContent(recommendedMatch);
            case 6:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function connectedCallback() {
        return _connectedCallback.apply(this, arguments);
      }
      return connectedCallback;
    }()
  }, {
    key: "handleGeolocationCookie",
    value: function handleGeolocationCookie() {
      var urlParams = new URLSearchParams(window.location.search);
      var geolocation = urlParams.get('geolocation');
      if (geolocation) {
        (0,_utils_CookieMethods__WEBPACK_IMPORTED_MODULE_0__.setCookie)('geolocation', geolocation, 30);
      }
    }
  }, {
    key: "toggleGeolocator",
    value: function toggleGeolocator() {
      var _this2 = this;
      this.classList.toggle('tw-hidden');
      this.setAttribute('geolocation-modal-active', this.getAttribute('geolocation-modal-active') === 'true' ? 'false' : 'true');
      setTimeout(function () {
        _this2.modal.classList.toggle('active');
      }, 300);
    }
  }, {
    key: "setupGeolocatorContent",
    value: function setupGeolocatorContent(recommendedMatch) {
      var _this3 = this;
      var geolocatorContent = this.geolocatorContentTemplate.content.cloneNode(true);
      var content = geolocatorContent.querySelector("[data-id=\"".concat(recommendedMatch.id, "\"]"));
      if (content) {
        this.geolocatorContentPlaceholder.appendChild(content);
      }
      this.countryModalToggle = this.querySelector('.country-modal-toggle');
      this.stayButton = this.querySelector('.stay-button');
      this.leaveButton = this.querySelector('.leave-button');
      this.countryModalToggle.addEventListener('click', function (event) {
        event.preventDefault();
        _this3.toggleCountryListModal(_this3.countryModalToggle);
      });
      this.stayButton.addEventListener('click', function (event) {
        event.preventDefault();
        (0,_utils_CookieMethods__WEBPACK_IMPORTED_MODULE_0__.setCookie)('geolocation', recommendedMatch.handle, 30);
        _this3.toggleGeolocator();
      });
      this.leaveButton.addEventListener('click', function (event) {
        event.preventDefault();
        var _this3$leaveButton$da = _this3.leaveButton.dataset,
          locale = _this3$leaveButton$da.locale,
          handle = _this3$leaveButton$da.handle,
          type = _this3$leaveButton$da.type;
        (0,_utils_CookieMethods__WEBPACK_IMPORTED_MODULE_0__.setCookie)('geolocation', 'handle', 30);
        var isMarket = type === 'market';
        if (!isMarket) {
          window.location.href = "".concat(window.location.href, "?geolocation=").concat(_this3.leaveButton.dataset.handle);
          return;
        }
        _this3.handleMarketSwitch(handle, locale);
      });
    }
  }, {
    key: "toggleCountryListModal",
    value: function toggleCountryListModal(trigger) {
      var geoLocatorActive = this.getAttribute('geolocation-modal-active') === 'true';
      // make it boolean
      var isInModalTrigger = trigger.dataset.inmodaltoggle === 'true';
      if (isInModalTrigger && !geoLocatorActive) {
        this.classList.toggle('tw-hidden');
        this.countryListModal.classList.toggle('active');
        return;
      }
      if (isInModalTrigger) {
        this.modal.classList.toggle('active');
        this.countryListModal.classList.toggle('active');
      } else {
        this.classList.toggle('tw-hidden');
        this.countryListModal.classList.add('active');
      }
    }
  }, {
    key: "initDataAndElements",
    value: function initDataAndElements() {
      this.modal = this.querySelector('#geolocator-modal');
      this.closeModalButton = this.querySelector('#close-geolocator-modal');
      this.geolocatorScript = this.querySelector('#geolocator-script');
      this.countryDataArray = JSON.parse(this.geolocatorScript.innerHTML);
      this.geolocatorContentTemplate = this.querySelector('#geolocator-content-tempalte');
      this.geolocatorContentPlaceholder = this.querySelector('#geolocator-content-placeholder');
      this.countryListModal = this.querySelector('#geolocator-countrylist-modal');
      this.closeCountryListModalButton = this.querySelector('#close-geolocator-countrylist-modal');
      this.countryListButtons = Array.from(this.querySelectorAll('.countrylist-button'));
      this.countryListModalToggles = Array.from(document.querySelectorAll('.country-modal-toggle'));
      this.overlay = this.querySelector('.geolocator-overlay');
    }
  }, {
    key: "addEventListeners",
    value: function addEventListeners() {
      var _this$closeModalButto,
        _this4 = this;
      (_this$closeModalButto = this.closeModalButton) === null || _this$closeModalButto === void 0 || _this$closeModalButto.addEventListener('click', function (event) {
        event.preventDefault();
        _this4.toggleGeolocator();
      });
      this.closeCountryListModalButton.addEventListener('click', function (event) {
        event.preventDefault();
        _this4.toggleCountryListModal(_this4.closeCountryListModalButton);
      });
      this.countryListButtons.forEach(function (button) {
        button.addEventListener('click', function (event) {
          event.preventDefault();
          _this4.handleCountryListButtonClick(button);
        });
      });
      this.countryListModalToggles.forEach(function (toggle) {
        toggle === null || toggle === void 0 || toggle.addEventListener('click', function (event) {
          event.preventDefault();
          _this4.toggleCountryListModal(toggle);
        });
      });
    }
  }, {
    key: "handleCountryListButtonClick",
    value: function handleCountryListButtonClick(button) {
      (0,_utils_CookieMethods__WEBPACK_IMPORTED_MODULE_0__.setCookie)('geolocation', button.dataset.handle, 30);
      var isMarket = button.dataset.type === 'market';
      if (!isMarket) {
        window.location.href = "".concat(window.location.href, "?geolocation=").concat(button.dataset.handle);
        return;
      }
      var _button$dataset = button.dataset,
        locale = _button$dataset.locale,
        handle = _button$dataset.handle;
      this.handleMarketSwitch(handle, locale);
    }
  }, {
    key: "handleMarketSwitch",
    value: function handleMarketSwitch(handle, locale) {
      var handleLower = handle.toLowerCase();
      if (handleLower === 'eu') {
        handleLower = 'ES';
      }
      var formId = crypto.randomUUID();
      var formElement = document.createElement('form');
      formElement.id = formId;
      formElement.action = '/localization';
      formElement.method = 'POST';
      formElement.hidden = true;
      formElement.innerHTML = "\n      <input name=\"_method\" value=\"PUT\">\n      <input name=\"country_code\" value=\"".concat(handleLower, "\">\n      <input name=\"language_code\" value=\"").concat(locale, "\">\n      <input name=\"return_to\" value=\"").concat(window.location.href, "?geolocation=").concat(handle, "\">\n    ");
      document.body.appendChild(formElement);
      formElement.submit();
    }
  }, {
    key: "getActiveCountryAndLanguage",
    value: function getActiveCountryAndLanguage() {
      var _window$Shopify = window.Shopify,
        country = _window$Shopify.country,
        locale = _window$Shopify.locale;
      return {
        country: country,
        locale: locale
      };
    }
  }, {
    key: "getRecommendedMatch",
    value: function getRecommendedMatch(browsingContext) {
      if (!browsingContext) return; // If no browsing context, return early
      var suggestedCountry = browsingContext.suggestedCountry,
        suggestedLanguage = browsingContext.suggestedLanguage,
        detectedCountry = browsingContext.detectedCountry;
      var countryHandle = (suggestedCountry === null || suggestedCountry === void 0 ? void 0 : suggestedCountry.handle) || (detectedCountry === null || detectedCountry === void 0 ? void 0 : detectedCountry.handle);
      var languageHandle = suggestedLanguage === null || suggestedLanguage === void 0 ? void 0 : suggestedLanguage.handle;
      if (!countryHandle) return;
      // Look for an exact match (country & language)
      var recommendedMatch = this.countryDataArray.find(function (country) {
        return country.handle === countryHandle && country.locale === languageHandle;
      });
      if (!recommendedMatch) {
        if (this.allEuCountries.includes(countryHandle)) {
          recommendedMatch = this.countryDataArray.find(function (country) {
            return country.handle === 'EU';
          });
        }
      }
      // If no exact match, look for a country-only match
      if (!recommendedMatch) {
        recommendedMatch = this.countryDataArray.find(function (country) {
          return country.handle === countryHandle;
        });
      }
      if (!recommendedMatch) {
        // find the country in countryDataArray that has primary set to true
        recommendedMatch = this.countryDataArray.find(function (country) {
          return country.primary;
        });
      }
      // In the end we either have
      // 1. An exact match on both country and language
      // 2. A match on country only
      // 3. A match on primary country
      // eslint-disable-next-line consistent-return
      return recommendedMatch;
    }
  }, {
    key: "getBrowsingContext",
    value: function () {
      var _getBrowsingContext = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var response, data, detectedValues, _detectedValues$count, handle, name, suggestions, suggestedCountry, suggestedLanguage, suggestion, browsingContext;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _context2.n = 1;
              return fetch('/browsing_context_suggestions.json?country[enabled]=true&language[enabled]=true');
            case 1:
              response = _context2.v;
              _context2.n = 2;
              return response.json();
            case 2:
              data = _context2.v;
              detectedValues = data.detected_values;
              _detectedValues$count = detectedValues.country, handle = _detectedValues$count.handle, name = _detectedValues$count.name;
              suggestions = data.suggestions;
              suggestedCountry = null;
              suggestedLanguage = null;
              if (suggestions.length) {
                // Check if there is a suggestion who has parts.country.handle which is equal to detectedValues.country.handle
                suggestion = suggestions.find(function (_suggestion) {
                  return _suggestion.parts.country.handle === detectedValues.country.handle;
                });
                suggestedCountry = suggestion === null || suggestion === void 0 ? void 0 : suggestion.parts.country;
                suggestedLanguage = suggestion === null || suggestion === void 0 ? void 0 : suggestion.parts.language;
              }
              browsingContext = {
                detectedCountry: {
                  handle: handle,
                  name: name
                },
                suggestedCountry: suggestedCountry,
                suggestedLanguage: suggestedLanguage
              };
              return _context2.a(2, browsingContext);
          }
        }, _callee2);
      }));
      function getBrowsingContext() {
        return _getBrowsingContext.apply(this, arguments);
      }
      return getBrowsingContext;
    }()
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));


/***/ }),

/***/ "./resources/scripts/components/Siblings/Siblings.ts":
/*!***********************************************************!*\
  !*** ./resources/scripts/components/Siblings/Siblings.ts ***!
  \***********************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ Siblings)
/* harmony export */ });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }
var Siblings = /*#__PURE__*/function (_HTMLElement) {
  function Siblings() {
    var _this;
    _classCallCheck(this, Siblings);
    _this = _callSuper(this, Siblings);
    _defineProperty(_this, "originalSelectedSiblingLabelElement", _this.querySelector('#selected-sibling_label'));
    _defineProperty(_this, "origialLabel", _this.originalSelectedSiblingLabelElement.innerText);
    _defineProperty(_this, "siblings", Array.from(_this.querySelectorAll('.product-sibling')));
    _this.mouseOverSibling = _this.mouseOverSibling.bind(_this);
    return _this;
  }
  _inherits(Siblings, _HTMLElement);
  return _createClass(Siblings, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      var _this2 = this;
      this.siblings.forEach(function (sibling) {
        sibling.addEventListener('mouseover', function () {
          _this2.mouseOverSibling(sibling);
        });
        sibling.addEventListener('mouseout', function () {
          _this2.mouseOutSibling();
        });
      });
    }
  }, {
    key: "mouseOverSibling",
    value: function mouseOverSibling(sibling) {
      var siblingLabel = sibling.dataset.label;
      this.originalSelectedSiblingLabelElement.innerText = siblingLabel;
    }
  }, {
    key: "mouseOutSibling",
    value: function mouseOutSibling() {
      this.originalSelectedSiblingLabelElement.innerText = this.origialLabel;
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));


/***/ }),

/***/ "./resources/scripts/utils/CookieMethods.ts":
/*!**************************************************!*\
  !*** ./resources/scripts/utils/CookieMethods.ts ***!
  \**************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "deleteCookie": () => (/* binding */ deleteCookie),
/* harmony export */   "getCookie": () => (/* binding */ getCookie),
/* harmony export */   "setCookie": () => (/* binding */ setCookie)
/* harmony export */ });
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function setCookie(name, value, minutes) {
  document.cookie = "".concat(name, "=").concat(value, ";max-age=").concat(minutes * 60, ";path=/");
}
function getCookie(name) {
  var cookies = document.cookie.split(';');
  var foundCookie = cookies.find(function (cookie) {
    var _cookie$split = cookie.split('='),
      _cookie$split2 = _slicedToArray(_cookie$split, 1),
      cookieName = _cookie$split2[0];
    return cookieName.trim() === name;
  });
  return foundCookie === null || foundCookie === void 0 ? void 0 : foundCookie.split('=')[1];
}
function deleteCookie(name) {
  document.cookie = "".concat(name, "=;max-age=0;path=/");
}

/***/ }),

/***/ "./resources/styles/app.css":
/*!**********************************!*\
  !*** ./resources/styles/app.css ***!
  \**********************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = __webpack_modules__;
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/chunk loaded */
/******/ 	(() => {
/******/ 		var deferred = [];
/******/ 		__webpack_require__.O = (result, chunkIds, fn, priority) => {
/******/ 			if(chunkIds) {
/******/ 				priority = priority || 0;
/******/ 				for(var i = deferred.length; i > 0 && deferred[i - 1][2] > priority; i--) deferred[i] = deferred[i - 1];
/******/ 				deferred[i] = [chunkIds, fn, priority];
/******/ 				return;
/******/ 			}
/******/ 			var notFulfilled = Infinity;
/******/ 			for (var i = 0; i < deferred.length; i++) {
/******/ 				var [chunkIds, fn, priority] = deferred[i];
/******/ 				var fulfilled = true;
/******/ 				for (var j = 0; j < chunkIds.length; j++) {
/******/ 					if ((priority & 1 === 0 || notFulfilled >= priority) && Object.keys(__webpack_require__.O).every((key) => (__webpack_require__.O[key](chunkIds[j])))) {
/******/ 						chunkIds.splice(j--, 1);
/******/ 					} else {
/******/ 						fulfilled = false;
/******/ 						if(priority < notFulfilled) notFulfilled = priority;
/******/ 					}
/******/ 				}
/******/ 				if(fulfilled) {
/******/ 					deferred.splice(i--, 1)
/******/ 					var r = fn();
/******/ 					if (r !== undefined) result = r;
/******/ 				}
/******/ 			}
/******/ 			return result;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/jsonp chunk loading */
/******/ 	(() => {
/******/ 		// no baseURI
/******/ 		
/******/ 		// object to store loaded and loading chunks
/******/ 		// undefined = chunk not loaded, null = chunk preloaded/prefetched
/******/ 		// [resolve, reject, Promise] = chunk loading, 0 = chunk loaded
/******/ 		var installedChunks = {
/******/ 			"/src/assets/app": 0,
/******/ 			"src/assets/app": 0
/******/ 		};
/******/ 		
/******/ 		// no chunk on demand loading
/******/ 		
/******/ 		// no prefetching
/******/ 		
/******/ 		// no preloaded
/******/ 		
/******/ 		// no HMR
/******/ 		
/******/ 		// no HMR manifest
/******/ 		
/******/ 		__webpack_require__.O.j = (chunkId) => (installedChunks[chunkId] === 0);
/******/ 		
/******/ 		// install a JSONP callback for chunk loading
/******/ 		var webpackJsonpCallback = (parentChunkLoadingFunction, data) => {
/******/ 			var [chunkIds, moreModules, runtime] = data;
/******/ 			// add "moreModules" to the modules object,
/******/ 			// then flag all "chunkIds" as loaded and fire callback
/******/ 			var moduleId, chunkId, i = 0;
/******/ 			if(chunkIds.some((id) => (installedChunks[id] !== 0))) {
/******/ 				for(moduleId in moreModules) {
/******/ 					if(__webpack_require__.o(moreModules, moduleId)) {
/******/ 						__webpack_require__.m[moduleId] = moreModules[moduleId];
/******/ 					}
/******/ 				}
/******/ 				if(runtime) var result = runtime(__webpack_require__);
/******/ 			}
/******/ 			if(parentChunkLoadingFunction) parentChunkLoadingFunction(data);
/******/ 			for(;i < chunkIds.length; i++) {
/******/ 				chunkId = chunkIds[i];
/******/ 				if(__webpack_require__.o(installedChunks, chunkId) && installedChunks[chunkId]) {
/******/ 					installedChunks[chunkId][0]();
/******/ 				}
/******/ 				installedChunks[chunkId] = 0;
/******/ 			}
/******/ 			return __webpack_require__.O(result);
/******/ 		}
/******/ 		
/******/ 		var chunkLoadingGlobal = self["webpackChunknordicliberty_dk"] = self["webpackChunknordicliberty_dk"] || [];
/******/ 		chunkLoadingGlobal.forEach(webpackJsonpCallback.bind(null, 0));
/******/ 		chunkLoadingGlobal.push = webpackJsonpCallback.bind(null, chunkLoadingGlobal.push.bind(chunkLoadingGlobal));
/******/ 	})();
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module depends on other loaded chunks and execution need to be delayed
/******/ 	__webpack_require__.O(undefined, ["src/assets/app"], () => (__webpack_require__("./resources/app.ts")))
/******/ 	var __webpack_exports__ = __webpack_require__.O(undefined, ["src/assets/app"], () => (__webpack_require__("./resources/styles/app.css")))
/******/ 	__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
/******/ 	
/******/ })()
;